export enum CronInterval {
	minute,
	hour,
	day,
	week,
	month,
	year,
}
